import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EFPicture from '@elem/ui/ef-picture';
import EfSectionMedia from '@elem/ui/ef-section-media';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState } from 'react';
import gtm from '@/utils/gtm';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const [active, setActive] = useState(-1);
    const pops = [
        {
            name: t('T_card1_title'),
            desc: t('T_card1_desc'),
        },
        {
            name: t('T_card2_title'),
            desc: t('T_card2_desc'),
        },
        {
            name: t('T_card3_title'),
            desc: t('T_card3_desc'),
        },
        {
            name: t('T_card4_title'),
            desc: t('T_card4_desc'),
        },
        {
            name: t('T_card5_title'),
            desc: t('T_card5_desc'),
        },
        {
            name: t('T_card6_title'),
            desc: t('T_card6_desc'),
        },
    ];

    const handleClickBtn = (k: number) => {
        setActive(k === active ? -1 : k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t('T_title'),
            button_name: pops[k === -1 ? active : k].name,
        });
    };

    const handleClickWraper = (e: any) => {
        const { className } = e.target;
        if (active !== -1 && !['pop-modal', 'pop-title', 'pop-desc'].includes(className)) {
            handleClickBtn(-1);
        }
    };

    return (
        <div className={styles.TheComp} onClick={handleClickWraper}>
            <EfSpec className="spec-xx l" />
            <EfTitle>{t('T_title')}</EfTitle>
            <div className="img-box">
                <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1721283746421/sl_pk.png'} alt={t('T_title')} />
                <ul className="pops">
                    {pops?.map((pop: any, k: number) => (
                        <li className={`pop${k === active ? ' active' : ''}${` pop${k + 1}`}`}>
                            <div className="btn" onClick={() => handleClickBtn(k)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M6.07938 14V7.91611H0V6.06181H6.07938V0H7.93164V6.06181H14V7.91611H7.93164V14H6.07938Z" fill="black" />
                                </svg>
                            </div>
                            <div className="pop-modal">
                                <p className="pop-title">{pop.name}</p>
                                <p className="pop-desc">{pop.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="text">
                {t.rich('U_text', {
                    title: (tx: string) => <p className="title">{tx}</p>,
                })}
            </div>
            <div className="images-container">
                <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1744597361847/PC_PK.png'} />
                <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1744597361677/Cables.png'} />
            </div>
        </div>
    );
}
